'use client';

import { useState } from 'react';

import { useSubscribe } from './use-subscribe';

export function FooterSubscribe() {
  const { status, error, submit } = useSubscribe('footer');
  const [email, setEmail] = useState('');
  const [hp, setHp] = useState('');

  if (status === 'pending') {
    return (
      <p className="subscribe-success" role="status">
        Check your inbox to confirm.
      </p>
    );
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        void submit(email, hp);
      }}
      noValidate
    >
      <div className="foot-subscribe-row">
        <input
          type="email"
          className="subscribe-input"
          placeholder="you@email.com"
          aria-label="Email address"
          aria-invalid={status === 'error'}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <button type="submit" className="btn btn-secondary" disabled={status === 'submitting'}>
          {status === 'submitting' ? 'Sending…' : 'Subscribe'}
        </button>
      </div>
      {/* honeypot */}
      <input
        className="subscribe-hp"
        type="text"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        value={hp}
        onChange={(e) => setHp(e.target.value)}
      />
      {status === 'error' && error && <p className="subscribe-error">{error}</p>}
    </form>
  );
}
